import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import PropTypes from "prop-types";
const SavePromptModal = ({ isOpen, onClose, currentPrompt, onPromptSave }) => {
  const [promptTitle, setPromptTitle] = useState(null);

  const handleSaveClick = () => {
    if (promptTitle.trim()) {
      onPromptSave(promptTitle);
      onClose();
    }
  };

  return (
    <Dialog onClose={onClose} open={isOpen} maxWidth="sm" fullWidth>
      <DialogTitle>Save Prompt</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <strong>Prompt: </strong>
          {currentPrompt}
        </DialogContentText>
        <TextField
          required
          margin="dense"
          id="promptTitle"
          name="promptTitle"
          label="Enter the title of the prompt"
          type="text"
          fullWidth
          variant="standard"
          value={promptTitle || ""}
          onChange={(e) => setPromptTitle(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ textTransform: "none" }}>
          Cancel
        </Button>
        <Button
          disabled={!promptTitle}
          type="submit"
          variant="contained"
          onClick={handleSaveClick}
          sx={{ textTransform: "none" }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

SavePromptModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  currentPrompt: PropTypes.string,
  onPromptSave: PropTypes.func.isRequired,
};

export default SavePromptModal;
